import { FunctionComponent, useCallback, useMemo } from 'react';
import CountUp from 'react-countup';

import { ConsumptionData } from '@/services/RewindApi';

const KeyStats: FunctionComponent<RewindSlideProps & ConsumptionData> = (props) => {
  const {
    total, tvShows, movies, topGenre, languages,
    active = true,
  } = props;
  const pageLoadDelay = 0.5;
  const countUpDuration = 1.5;

  const statsData = useMemo(() => {
    return [
      { label: 'Minutes watched', value: total },
      { label: 'TV Shows', value: tvShows },
      { label: 'Movies', value: movies },
      { label: `Minutes of ${topGenre.name}`, value: topGenre.time },
      { label: 'Languages', value: languages },
    ];
  }, [languages, movies, topGenre, total, tvShows]);

  const renderStatsEntry = useCallback((label: string, value: number, delay: number = 0) => {
    return (
      <div key={label} className="flex flex-col gap-2 lg:gap-7">
        <div className="font-ubuntu text-2xl lg:text-4xl font-bold min-w-[210px]">
          {active ? (
            <CountUp
              start={0}
              end={value}
              delay={delay}
              separator=","
              duration={countUpDuration}
            />
          ) : value.toLocaleString()}
        </div>
        <div className="font-ubuntu text-base font-bold text-dark-tangerine uppercase">{label}</div>
      </div>
    );
  }, [active, countUpDuration]);

  const stats = useMemo(() => {
    let nbEntriesRendered = 0;
    let delay = pageLoadDelay;

    return statsData.map((statsEntry, index) => {
      if (statsEntry.value > 0) {
        if (statsEntry.label === 'Languages' && nbEntriesRendered === 4) {
          return null;
        }

        if (index > 0) {
          // If the previous entry had a small value, then don't delay the current one too long
          delay += statsData[index - 1].value > 6 ? countUpDuration : 0.8;
        }

        nbEntriesRendered += 1;
        return renderStatsEntry(statsEntry.label, statsEntry.value, delay);
      }

      return null;
    });
  }, [statsData, renderStatsEntry]);

  return (
    <div className="flex flex-col lg:flex-row gap-12 xl:gap-24 slide-up">
      {stats}
    </div>
  );
};

export default KeyStats;
